import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './ProposalsTable.css';
import SimpleTable from '../../../../shared/table/SimpleTable';
import Date from '../../../../shared/text/Date';
import Number from '../../../../shared/text/Number';
import numeral from 'numeral';
import { ProposalStatus } from 'domain/proposal-status-enum';

class ProposalsTable extends Component {
  static propTypes = {
    proposalRenderer: PropTypes.func,
    proposals: PropTypes.array.isRequired,
    changeOrders: PropTypes.array,
    approvedProposal: PropTypes.object,
    changeOrderRenderer: PropTypes.func,
    showHeader: PropTypes.bool,
    onRowSelected: PropTypes.func,
  };

  static defaultProps = {
    proposalRenderer: (proposalNumber) => {
      return proposalNumber;
    },
    showHeader: true,
  };

  handleRowSelect = (proposalId) => {
    if (proposalId[0] === '_') {
      this.props.onChangeOrderRowSelected(proposalId.substr(1));
    } else {
      this.props.onRowSelected(proposalId);
    }
  };

  render() {
    let headers = [];
    if (this.props.showHeader) {
      headers = ['PROPOSAL #', 'STATUS', 'DATE RECEIVED', 'AMOUNT'];
    }

    return (
      <div className="proposals-table-container">
        <SimpleTable
          className="proposals-table"
          headers={headers}
          rows={this.createRows(this.props.proposals).concat(
            this.createChangeOrderRows(this.props.changeOrders)
          )}
          onRowSelected={this.handleRowSelect}
        />
      </div>
    );
  }

  createRows(proposals) {
    const rows = [];

    proposals.forEach((proposal) => {
      rows.push({
        id: proposal.id,
        data: [
          <span className="proposal-number">
            {this.props.proposalRenderer(proposal.number)}
          </span>,
          ProposalsTable.createStatusElement(
            proposal.status,
            proposal.rejected_reason_1,
            proposal.rejected_reason_2
          ),
          <Date value={proposal.created_at} format="M/D/YYYY" />,
          <Number value={proposal.cost} format="$0,0" />,
        ],
      });
    });

    return rows;
  }

  createChangeOrderRows(changeOrders) {
    const rows = [];

    if (changeOrders.length > 0) {
      let cost = numeral(this.props.approvedProposal.cost).value();
      changeOrders.forEach((co) => {
        rows.push({
          id: `_${co.id}`,
          data: [
            <span className="proposal-number">
              {this.props.changeOrderRenderer(co.number)}
            </span>,
            ProposalsTable.createStatusElement(co.status),
            <Date value={co.created_at} format="M/D/YYYY" />,
            <Number value={cost + numeral(co.cost).value()} format="$0,0" />,
          ],
        });

        if (ProposalStatus.APPROVED.equals(co.status)) {
          cost += numeral(co.cost).value();
        }
      });
    }

    return rows;
  }

  static createStatusElement(status, rejectedReason1, rejectedReason2) {
    let reason = '';
    if (rejectedReason1) {
      reason =
        `(${rejectedReason1}` +
        (rejectedReason2 ? `: ${rejectedReason2})` : ')');
    }

    return (
      <div className="status-container">
        <div>{status.charAt(0).toUpperCase() + status.slice(1)}</div>
        <div className={'status ' + status} />
        {reason && <div>{reason}</div>}
      </div>
    );
  }
}

export default ProposalsTable;



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/proposals/ProposalsTable.js